// extracted by mini-css-extract-plugin
export var el = "button-module--el--fOp4o";
export var el_normal = "button-module--el_normal--AsYLv";
export var el_medium = "button-module--el_medium--iwekH";
export var el_gray = "button-module--el_gray--2zOcR";
export var isFullWidth = "button-module--isFullWidth--v34KO";
export var box_shadow = "button-module--box_shadow--FxbsR";